var map = {
	"./auditorio.jpg": 1259,
	"./aula.jpg": 1260,
	"./avion.jpg": 1261,
	"./biblioteca.jpg": 1262,
	"./bolsa.jpg": 1263,
	"./campo.jpg": 1264,
	"./cocina.jpg": 1265,
	"./espiritual.jpg": 1266,
	"./espiritual2.jpg": 1267,
	"./espiritual3.jpg": 1268,
	"./espiritual4.jpg": 1269,
	"./fondo-marino.jpg": 1270,
	"./greenhouse.jpg": 1271,
	"./hospital.jpg": 1272,
	"./industria.jpg": 1273,
	"./juzgado.jpg": 1274,
	"./laboratorio.jpg": 1275,
	"./mar.jpg": 1276,
	"./montana.jpg": 1277,
	"./obras.jpg": 1278,
	"./ordenadores.jpg": 1279,
	"./polideportivo.jpg": 1280,
	"./puerto.jpg": 1281,
	"./reception.jpg": 1282,
	"./super.jpg": 1283,
	"./taller.jpg": 1284,
	"./tallerartesania.jpg": 1285,
	"./teatro.jpg": 1286,
	"./terapia.jpg": 1287,
	"./tiendaropa.jpg": 1288,
	"./tractor.jpg": 1289,
	"./veterinario.jpg": 1290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1258;